import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

interface DemoDrawerContextValue {
  isOpen: boolean;
  url: string;
  open: (url?: string) => void;
  close: () => void;
}

const DEFAULT_CALENDLY = "https://calendly.com/vasco-galvao/nova-reuniao";

const DemoDrawerContext = createContext<DemoDrawerContextValue>({
  isOpen: false,
  url: DEFAULT_CALENDLY,
  open: () => undefined,
  close: () => undefined
});

export const DemoDrawerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [url, setUrl] = useState<string>(DEFAULT_CALENDLY);

  const open = useCallback((customUrl?: string) => {
    setUrl(customUrl ?? DEFAULT_CALENDLY);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, url, open, close }), [isOpen, url, open, close]);
  return <DemoDrawerContext.Provider value={value}>{children}</DemoDrawerContext.Provider>;
};

export const useDemoDrawer = (): DemoDrawerContextValue => useContext(DemoDrawerContext);

// Helper: does this href point at the Calendly booking flow? Used by
// CTA handlers to decide whether to open the drawer or follow the link
// normally.
export const isCalendlyHref = (href?: string | null): boolean => {
  if (!href) return false;
  return href.includes("calendly.com");
};
